import {
  MobileMenuItem,
  MobileMenuItems,
} from '@web-libs/features/navigation/mobile-menu-items';
import { useTageaRouter } from '@web-libs/core/routing/application/use-tagea-router.concern';
import { routes } from '@web-app/[lang]/[tenant]/[institution]/routes-institution';
import { useChat } from '@web-libs/features/chat/application/use-chat.context';
import { useInvitations } from '@web-libs/features/appointments/application/invitations/use-invitations';
import { useDictionaryContext } from '@web-libs/core/internationalization/dictionary.context';
import { useTageaConfig } from '@web-libs/core/config/config';

export const PrivateMobileMenu = ({ close }: { close: () => void }) => {
  const router = useTageaRouter();
  const chat = useChat();
  const invitations = useInvitations();
  const unreadInvitations = invitations.invitations.length > 0;
  const dictMenu = useDictionaryContext().menu;
  const { isFeatureDisabled } = useTageaConfig();

  const menuItems: MobileMenuItem[] = [
    {
      name: dictMenu.dashboard,
      onClick: () => {
        router.push(routes.dashboard);
      },
      active: router.isCurrentPath(routes.dashboard),
    },
    {
      name: useDictionaryContext().angular.myArea.header,
      onClick: () => {
        router.push(routes.myArea);
      },
      active: router.isCurrentPath(routes.myArea),
    },
    {
      name: dictMenu.chat,
      onClick: () => {
        router.push(routes.chat);
      },
      active: router.isCurrentPath(routes.chat),
      indicator: chat.isUnreadMessageAvailable,
    },
    {
      name: dictMenu.appointments,
      onClick: () => {
        router.push(routes.appointments);
      },
      active: router.isCurrentPath(routes.appointments),
      indicator: unreadInvitations,
    },
    ...(isFeatureDisabled('feature.customForms')
      ? []
      : [
          {
            name: dictMenu.forms,
            onClick: () => {
              router.push(routes.ownCustomForms);
            },
            active: router.isCurrentPath(routes.ownCustomForms),
          },
        ]),
    ...(isFeatureDisabled('feature.sharedClientInstDir')
      ? []
      : [
          {
            name: dictMenu.fileStorage,
            onClick: () => {
              router.push(routes.fileStorage);
            },
            active: router.isCurrentPath(routes.fileStorage),
          },
        ]),
    {
      name: dictMenu.settings,
      onClick: () => {
        router.push(routes.profile);
      },
      active: router.isCurrentPath(routes.profile),
    },
    {
      name: 'Impressum',
      onClick: () => {
        router.push(routes.impressum);
      },
      secondary: true,
    },
    {
      name: 'Datenschutz',
      onClick: () => {
        router.push(routes.datenschutz);
      },
      secondary: true,
    },
  ];

  return <MobileMenuItems items={menuItems} close={close}></MobileMenuItems>;
};
